import React, {useState} from 'react';
import {Layout, Permissions, Icon, Icons, Flex, Button, Goals, Video, Separator} from 'components';
import {map, config, modal, printSidebar, useDragStart, useDrop, useList, useNamedSelector} from 'helpers';
import {forbid} from 'store/session';
import {update} from 'store/sorting';

export function Sidebar({match: {params: {id, page = ''}}}) {
  let heading = '';
  const base = '/goals/'.concat(page, page ? '/' : '');
  const [q, setSearch] = useState('');

  const goals = useNamedSelector('goals.list', {
    module: 'goals',
    filter: useNamedSelector('settings.shareStatusFilter', {context: 'goals'})
  });

  const permissions = useNamedSelector('permissions.list');
  const createNew = permissions.canAdd.goals ? modal(Goals.Single.SelectCategory) : forbid;

  const [list, Last] = useList(goals, {
    search: {q, keys: ['name', 'note']}
  });

  const onDrop = (event, grabbed) => {
    update({
      all: map(goals, 'id').filter(Boolean),
      container: event.currentTarget,
      grabbed,
      name: 'Goals'
    });
  };

  return (
    <Layout.Sidebar {...useDrop(onDrop, grabbed => grabbed.type === 'goal')}>
      {!page &&
        <Flex className={['secondary', 'middle', 'hidden-print']}>
          <Layout.Sidebar.Search value={q} setValue={setSearch} />
          <Icons.Print onClick={printSidebar} />
          { config.videos.goals &&
            <Video.Trigger src={config.videos.goals} />
          }
          <Goals.SidebarPreferences shareStatus />
          <Icon name="plus-large" title="Add Goal" onClick={createNew} />
        </Flex>
      }
      <Layout.Sidebar.Scrollable>
        { list.map(goal => goal.heading !== undefined
          ? <Separator key={heading = goal.heading} heading={goal.heading} />
          : <Goals.Single.Card
              hasChart={page === 'track'}
              hasThumbnail={!page}
              id={goal.id}
              key={heading + goal.id}
              navLink={`${base}${goal.id}/`}
              hasDropZone
              {...useDragStart({type: 'goal', id: goal.id})}
            />
        ) }
        <Last />
        { list.length == 0 &&
          <p className="text-center">Add goals that need to be accomplished. </p>
        }
        {!page &&
          <>
            <p className="hidden-print">
              <Button icon="plus" className={['stretch', 'primary']} onClick={createNew}>
                New Goal
              </Button>
            </p>
          </>
        }
        <Permissions.Alert module="goals" />
      </Layout.Sidebar.Scrollable>
    </Layout.Sidebar>
  );
}
